import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c(VRow,{attrs:{"justify":"center"}},[_c(VCol,{attrs:{"cols":"12","md":"11","xl":"8"}},[_c('CommentMenu',{attrs:{"comments":_vm.candidateComments,"candidate-id":_vm.candidateId}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }